import styled, { css } from "styled-components";

export const Td = styled.td`
  min-width: calc(100vw / 9.5);
  width: 100% !important;
  margin-top: auto;
  margin-bottom: auto;
  font-size: ${props => props.fontSize}px;
  font-family: ${props => props.fontStyle};
  word-break: break-all;

  &:not(:first-child),
  &:not(:nth-child(2)) {
    text-align: center;
  }
`;

export const Tr = styled.tr`
  min-width: 100%;
  width: 100% !important;

  &:not(:last-child) {
    border-bottom: 1px solid #b4b5b5;
  }
`;

export const Th = styled.th`
  padding: 18px 5px;
  font-weight: bold;
  font-size: ${props => props.fontSize}px;
  font-family: ${props => props.fontStyle};
  min-width: calc(100vw / 9.5);
  width: 100% !important;
  background-color: ${props => props.headerColor};

  &:not(:first-child),
  &:not(:nth-child(2)) {
    text-align: center;
  }

  text {
    display: flex;
    margin: auto;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
`;

export const Tbody = styled.tbody`
  display: inline-block;
  min-width: 100%;
`;

export const Thead = styled.thead`
  position: relative;
  top: 0;
  z-index: 3;
  display: inline-block;
  min-width: 100%;
  margin-bottom: 3px;
`;

export const Table = styled.table`
  min-width: 100%;
  color: ${props => props.textColor};
  background-color: ${props => props.backgroundColor};
  display: table;
`;

export const TableWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 0px;
  max-height: 375px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  display: block;
  margin-left: auto;
  margin-right: auto;

  ${props =>
    props.tableHeight &&
    css`
      @media (min-width: 576px) {
        max-height: ${props.tableHeight.sm};
      }
      @media (min-width: 768px) {
        max-height: ${props.tableHeight.md};
      }
      @media (min-width: 992px) {
        max-height: ${props.tableHeight.lg};
      }
      @media (max-width: 950px) {
        max-width: 800px;
      }
      @media (max-width: 850px) {
        max-width: 650px;
      }
      @media (max-width: 750px) {
        max-width: 500px;
      }
      @media (max-width: 650px) {
        max-width: 400px;
      }
      @media (max-width: 500px) {
        max-width: 300px;
      }
    `}
`;
